import graphql__6cb646333bfb37bb5693 from "./__generated__/CityWalkWaypointContributionForm_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import { Navigate, useParams } from "react-router";

import { useRoutesContext } from "../Routes/RoutesContext";
import FormPage from "../ParticipativeModule/FormPage";

const CityWalkWaypointContributionForm = props => {
  const contribution = useFragment(
    CityWalkWaypointContributionForm_contribution,
    props.contribution
  );
  const { edit } = props;
  const { formHash, currentPage } = contribution;
  const { pathFor } = useRoutesContext();
  const redirectPath = pathFor("cityWalkWaypoint", useParams());

  if (currentPage) {
    return (
      <FormPage
        key={currentPage.id}
        currentPageId={currentPage.id}
        formKey={formHash}
        intlMessages={intlMessages}
        contribution={contribution}
        edit={edit}
        redirectPath={redirectPath}
      />
    );
  } else {
    return <Navigate to={redirectPath} />;
  }
};

const CityWalkWaypointContributionForm_contribution = graphql__6cb646333bfb37bb5693;

export default CityWalkWaypointContributionForm;

const intlMessages = defineMessages({
  title: {
    id: "cityWalk.step.contribution.form.title",
    defaultMessage: "Donner mon avis sur le point"
  },
  signInMessage: {
    id: "cityWalk.step.contribution.form.signInMessage",
    defaultMessage: `
      Merci de vous identifier pour pouvoir valider le dépôt de votre
      contribution.
    `
  },
  successMessage: {
    id: "cityWalk.step.contribution.form.successMessage",
    defaultMessage: `
      Votre avis a bien été pris en compte. Merci pour votre participation !
    `
  }
});
